module.exports = __webpack_public_path__ + "img/test_Icon7.073ac68e.png";